

const SalesPrediction = (trends, NATrends, depth, ROG, salesTarget) => {

  let targetTrends = []
  trends.forEach(trend => {
    const newTrend = {
      tag: trend.tag,
      value: trend.value,
      trendTag: trend.tag,
      trendValue: trend.value,
      depth: trend.depth,
      rateOfGrowth: trend.rateOfGrowth,
      score: Math.max(ROG * trend.rateOfGrowth + depth * trend.depth, 0)

    }
    targetTrends.push(newTrend);
  })
  if (NATrends) {
    NATrends.forEach(trend => {
      const newTrend = {
        tag: trend.tag,
        value: trend.value,
        trendTag: trend.tag,
        trendValue: trend.value,
        depth: trend.depth,
        rateOfGrowth: trend.rateOfGrowth,
        score: Math.max(ROG * trend.rateOfGrowth + depth * trend.depth, 0)
      }
      targetTrends.push(newTrend);
    })
  }
  //    targetTrends = targetTrends.filter(t => t.score > 0);
  const scoreSum = targetTrends.reduce((prev, current) => {
    return prev + current.score;
  }, 0)

  targetTrends.forEach(trend => {
    trend.sales = Math.round(trend.score * salesTarget / scoreSum)
  })

  targetTrends = targetTrends.sort((a, b) => {
    return b.sales - a.sales
  })

  return targetTrends

}

export default SalesPrediction
